<template>
  <div></div>
</template>
<script>
export default {
  name: 'Logout',

  created () {
    this.$cookies.remove('access_token')
    this.$router.push({ name: 'auth.login' })
  }
}
</script>
